export function removePortalElement(portalId: string) {
    const portalElement = document?.getElementById(portalId);

    if (!portalElement) {
        return;
    }

    return portalElement?.parentNode?.removeChild(portalElement);
}
